// extracted by mini-css-extract-plugin
module.exports = {"swiper":"posts_carousel_swiper__tvbNq","swiperSlide":"posts_carousel_swiperSlide__g10MG"};